enum Allergencode {
  GLUTEN,
  CRAB,
  EGGS,
  FISH,
  PEANUTS,
  SOY,
  MILK,
  EDIBLENUT,
  CELERY,
  MUSTARD,
  SESAME,
  SULFITE,
  LUPINE,
  MOLLUSCS
}

abstract class Allergencodes {
  /**
   * Returns the i18n message key for the given allergen code. This key can be used in translation functions.
   * @param code Allergencode
   */
  public static getNameKey(code: Allergencode): string {
    if (Object.values(Allergencode).includes(code)) {
      return 'common.product.allergencode.' + Allergencode[code].toLowerCase();
    } else {
      throw Error('Unknown allergen code ' + code);
    }
  }
}

export { Allergencode, Allergencodes };
